import { Routes, Route } from "react-router-dom";
import { RequestorInformation } from "./Welcome";
import EligibilityCheck from "./PriorAuthWorkFlow/containers/EligibilityCheck";
import ReferralRequest from "./PriorAuthWorkFlow/containers/index";

const RouteMapping: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<RequestorInformation />} />
      <Route path="/check-eligibility" element={<EligibilityCheck />} />
      <Route path="/prior-auth-workflow" element={<ReferralRequest />} />
    </Routes>
  );
};

export default RouteMapping;
